<template>
    <v-dialog
        v-model="commitDialog"
        persistent
        width="500"
    >
        <v-toolbar outlined dark color="accent" class="title">
            <v-icon left>fas fa-plus-circle</v-icon>
            Add a note:
        </v-toolbar>
        <v-card outlined flat>
            <v-container fill-height fluid>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-textarea v-model="commitMessage" flat outlined color="secondary" label="Please enter notes regarding this update."></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6" class="text-center">
                        <v-btn @click="$emit('close')" outlined color="red">
                            <v-icon left>fas fa-times</v-icon>
                            Cancel
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="6" class="text-center">
                        <v-btn @click="commit()" outlined>
                            <v-icon left>fas fa-save</v-icon>
                            Save
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>

</template>

<script>
export default {
    props: {
        commitDialog: Boolean
    },
    data(){
        return {
            commitMessage: ""
        }
    },
    methods: {
        commit(){
            let commitRecord = {
                author  : this.getAuthor,
                msg     : this.commitMessage 
            }
            this.$emit('commit', commitRecord)
        }
    },
    computed: {
        getAuthor(){
            return this.$store.getters.getUser
        }
    }
}
</script>